import { ErrorHandler, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GlobalErrorHandler } from './global-error-handler';
import { HttpErrorInterceptor } from './http-error-interceptor';

/**
 * Infra de ERROS do tenant (Fase 2 — Erros MVP).
 *
 * - `ErrorHandler` global (erros não tratados → ingest);
 * - `HttpErrorInterceptor` (5xx → ingest + feedback ao usuário; anti-loop).
 *
 * Importado pelo CoreModule — os providers ficam no injetor raiz, como os
 * demais interceptors (AuthInterceptor, MaintenanceInterceptor).
 */
@NgModule({
    providers: [
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true,
        },
    ],
})
export class ErrorModule {
}